import { render, staticRenderFns } from "./UserIngredients.vue?vue&type=template&id=03dbf4c2&scoped=true"
import script from "./UserIngredients.vue?vue&type=script&lang=js"
export * from "./UserIngredients.vue?vue&type=script&lang=js"
import style0 from "./UserIngredients.vue?vue&type=style&index=0&id=03dbf4c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbf4c2",
  null
  
)

export default component.exports